import React from 'react';

const CategoryPage = () => (
  <div className="underContruction">
    <h1>Under construction!!</h1>
  </div>
);

export default CategoryPage;
